export const normalizePrivilegePath = (path = "") => {
  const pathOnly = String(path || "").split(/[?#]/)[0].trim();
  if (!pathOnly) return "";

  const withSlash = pathOnly.startsWith("/") ? pathOnly : `/${pathOnly}`;
  const withoutTrailingSlash = withSlash.replace(/\/+$/, "");
  return withoutTrailingSlash || "/";
};

const isTicketScannerPath = (path = "") => {
  const normalizedPath = normalizePrivilegePath(path);
  return normalizedPath === "/ticketScanner" || normalizedPath.startsWith("/ticketScanner/");
};

const isCommunicationPath = (path = "") => {
  const normalizedPath = normalizePrivilegePath(path);
  return normalizedPath === "/communication" || normalizedPath.startsWith("/communication/");
};

const isWhatsappPath = (path = "") => {
  const normalizedPath = normalizePrivilegePath(path);
  return normalizedPath === "/whatsapp" || normalizedPath.startsWith("/whatsapp/");
};

const TICKET_CLASS_CHILD_PATHS = {
  "/registration/ticket-class": [
    "/registration/ticket-class/new",
    "/registration/ticket-class/edit/",
    "/registration/ticket-class/duplicate/",
    "/registration/master-ticket-class/new",
    "/registration/master-ticket-class/edit/",
  ],
  "/private/ticket-class": [
    "/private/ticket-class/new",
    "/private/ticket-class/edit/",
    "/private/master-ticket-class/new",
    "/private/master-ticket-class/edit/",
  ],
  "/exhibitor/ticket-class": [
    "/exhibitor/ticket-class/new",
    "/exhibitor/ticket-class/edit/",
    "/exhibitor/master-ticket-class/new",
    "/exhibitor/master-ticket-class/edit/",
  ],
  "/speaker/ticket-class": [
    "/speaker/ticket-class/new",
    "/speaker/ticket-class/edit/",
  ],
  "/sponsor/ticket-class": [
    "/sponsor/ticket-class/new",
    "/sponsor/ticket-class/edit/",
  ],
};

const matchesTicketClassChildPath = (allowed, current) => {
  const childPaths = TICKET_CLASS_CHILD_PATHS[allowed];
  if (!childPaths) return false;
  return childPaths.some((path) => (
    path.endsWith("/") ? current.startsWith(path) : current === path
  ));
};

export const matchesPrivilegePath = (allowedPath, currentPath) => {
  const allowed = normalizePrivilegePath(allowedPath);
  const current = normalizePrivilegePath(currentPath);
  if (!allowed || !current) return false;

  if (isTicketScannerPath(allowed) && isTicketScannerPath(current)) {
    return current === allowed || current.startsWith(`${allowed}/`);
  }

  if (isCommunicationPath(allowed) && isCommunicationPath(current)) {
    return current === allowed || current.startsWith(`${allowed}/`);
  }

  if (isWhatsappPath(allowed) && isWhatsappPath(current)) {
    return current === allowed || current.startsWith(`${allowed}/`);
  }

  if (matchesTicketClassChildPath(allowed, current)) {
    return true;
  }

  return current === allowed;
};
